import { IEvent, IEventCategory, IEventPreview } from '@/interfaces/events'
import { IBlock } from '@/interfaces/blocks'
import { mapImageFields } from '@/adapters/common'
import { blockMapper } from '@/adapters/blocks'

export function mapEventCategoryFields(item: Directus.EventCategory): IEventCategory {
  const { translations, sort_children_by, ...rest } = item
  return { ...rest, ...translations[0], sort_children_by: sort_children_by || undefined }
}

export function mapEventPreviewFields(item: Directus.EventPreview): IEventPreview {
  return {
    id: item.id,
    slug: item.slug,
    date_start: item.date_start,
    date_end: item.date_end,
    is_pinned: item.is_pinned,
    age_restriction: item.age_restriction,
    image_preview: mapImageFields(item.image_preview),
    category: mapEventCategoryFields(item.category),
    ...item.translations[0],
  }
}

export function mapEventFields(item: Directus.Event, locale: string): IEvent {
  const previewFields = mapEventPreviewFields(item)
  return {
    ...previewFields,
    blocks: item.blocks
      .filter(b => !!b.item)
      .map((block: Directus.Block) => {
        try {
          return blockMapper.get(block.collection)?.call(null, block, locale)
        } catch (error) {
          return null
        }
      })
      .filter(b => !!b?.data) as IBlock[],
    stages: item.stages.map((stage: Directus.EventStage) => {
      return {
        ...stage.translations[0],
      }
    }),
  }
}
